import React from "react";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import WelcomeContainer from "./Containers/WelcomeContainer";
import DashboardContainer from "./Containers/DashboardContainer/DashboaredContainer";
import LanguageContainer from "./Containers/LanguageContainer";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
function App() {
  return (
    <>
      <FluentProvider theme={teamsLightTheme}>
        <LanguageContainer />
        <AuthenticatedTemplate>
          <DashboardContainer />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <WelcomeContainer />
        </UnauthenticatedTemplate>
      </FluentProvider>
    </>
  );
}

export default App;
